import { render } from "./SaveInterviewAttachment.vue?vue&type=template&id=09972f4e"
import script from "./SaveInterviewAttachment.vue?vue&type=script&lang=js"
export * from "./SaveInterviewAttachment.vue?vue&type=script&lang=js"

import exportComponent from "/build/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__